<template>
  <div>
    <navbar :isAgent="true">
      <template v-slot:actionButton>
        <div class="buttons">
          <b-button rounded outlined class="is-primary" @click="$router.push({name:'agentSignin'})">Sign In</b-button>
        </div>
      </template>

    </navbar>

    <div class="container" style="margin-top: 5%">
      <div class="columns" style="height: 600px">
        <div class="column">
          <div class="box ml-5" style="width: 150%; height: 100%">
            <img  :src="require('@/assets/gifs/animation_640_l58gh1e8.gif')" alt="signup-gif" style="height: 550px;" align="left">
          </div>
        </div>
        <div class="column">
          <div class="box-1" style="height: 105%; margin-top: -2%">
            <div style="width: 90%">
              <p class="signIn is-size-1">Verify Your Account</p>
              <p style="color: #8C8C9B">We have sent an OTP to <b>jasXXXXXXXXX@gmail.com</b> <br>Please check your e-mail and enter OTP code below</p>
              <div style="margin-top: 15%">
                <b-field
                    type="is-info"
                    label="OTP Code"
                    style="font-size: 100px; color: #0d5da3"
                    :label-position="labelPosition"
                >
                  <b-input
                      type="number"
                      v-model="OTP"
                      maxlength="4"
                      rounded
                  ></b-input>
                </b-field>
              </div>


              <div class="columns mt-2">
                <div class="column">
                 <p style="text-align: left">Didn't Receive? <a href="" style="font-weight: bold">Click Here</a></p>
                </div>
                <div class="column">
                  <p style="text-align: right">Resend OTP in <span style="color:#0D5DA3; font-weight: bold ">30s</span></p>
                </div>
              </div>

              <div style="margin-top: 10%">
                <div class="buttons">
                  <b-button type="is-primary" outlined rounded expanded  @click="$router.push({name:'agentDashboard'})">Confirm</b-button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import Navbar from '@/components/common/Navbar'
export default {
  name:"saccount-verify",

  components:{
    Navbar
  },

  data(){
    return{
      labelPosition: "on-border",
      OTP:null
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .box{
    display: none;
  }

}
.signIn {
  padding-top: 30px;
  font-weight: bold;
  background: -webkit-linear-gradient(#3a8fff 0 30%, #0837ae 55% 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

p {
  color: gray;
  font-weight: 500;
}
.link {
  color: #0d5da3;
  text-decoration: underline;
  cursor: pointer;
}
.link:hover {
  color: #092bc2;
  text-shadow: 1px;
}

.box-1 {
  position: relative;
  z-index: 1;
  background-color: white;
  border-radius: 0 15px 15px 0;
  box-shadow: 0 -5px 5px -5px #333, 5px 0 5px -5px #333, 0 5px 5px -5px #333;
}
.box-1::before {
  position: absolute;
  left: -5%;
  content: "";
  width: 70px;
  z-index: -1;
  height: 100%;
  background-color: inherit;
  border-radius: 15px 0 0 15px;
  box-shadow: 0 -1px 5px -5px #333, -5px 0 5px -5px #333, 1px 5px 0px -5px #333;
  /* box-shadow: 0px 10px 0px 0 rgb(41, 33, 33); */
  transform: skew(-5deg);
}
</style>
